import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from '../base-form/base-form.component';

@Component({
  selector: 'app-custos-recursos',
  templateUrl: './custos-recursos.component.html',
  styleUrls: ['./custos-recursos.component.scss']
})
export class CustosRecursosComponent extends BaseFormComponent implements OnInit {

  public tipoTrabalho: string;
  @Input() visualizar: boolean;
  @Input() hiddenEdicao: boolean;

  totalEquipePlanejado = 0;
  totalOutrosPlanejado = 0;
  totalEquipeExecucao = 0;
  totalOutrosExecucao = 0;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
  }
}
